<div class="quiz-container">
  <div class="quiz-header card-style">
	<ng-container *ngIf="isLoading; else pageContent">
        <div class="small-spinner ">
          <mat-spinner diameter="30"></mat-spinner>
       </div>
    </ng-container>

	<ng-template #pageContent>
    <div class="quiz-path" *ngIf="fullQuizData">
      <i class="bi bi-arrow-left-short" (click)="goToClassroomDetailPage()"> </i>
      <span class="semester">{{ fullQuizData.classroom_name}}</span>
      <span class="separator">•</span>
      <span class="topic">{{ fullQuizData.subject}}</span>
    </div>

    <div class="quiz-title" *ngIf="fullQuizData">
      <span>{{fullQuizData.quiz_name || '-'}}
     <i class="bi bi-pencil edit-icon ms-2" (click)="openEditTitleBox(false)"> </i>   </span>
  </div>

  <div class="text-end fw-bold">
	Time Limit
	<span class="quiztime ms-2">{{ formatTime(fullQuizData.time_limit || 0)}} 
		 <i  class="bi bi-pencil edit-icon ms-2" (click)="openEditTitleBox(true)"></i></span>
  </div>
     </ng-template>
   </div>

  <div class="quiz-mode-tabs">
    <button (click)="selectMode('manual')" [class.active]="selectedMode === 'manual'"><i
        class="bi bi-pencil-square"></i>Create Manually</button>
    <button (click)="selectMode('ai')" [class.active]="selectedMode === 'ai'"><i class="bi bi-stars"></i> Generate with
      AI</button>
    <button (click)="selectMode('course')" [class.active]="selectedMode === 'course'"><i
        class="bi bi-journal-bookmark"></i>From Course</button>
  </div>

  <app-manual-mode *ngIf="selectedMode === 'manual'"></app-manual-mode>
  <app-ai-mode *ngIf="selectedMode === 'ai'" (switchMode)="selectMode($event)"></app-ai-mode>
  <app-course-mode *ngIf="selectedMode === 'course'" (switchMode)="selectMode($event)"></app-course-mode>

  <div class="footer">
    <h6 class="warning"><i class=" text-warning bi bi-exclamation-triangle-fill"></i> AI can make mistakes. Please review before publishing.</h6>
	<button class="btn-primary" (click)="goToQuizPage()" [disabled]="!quizDataExists">Review & Edit Questions</button>
  </div>
</div>